export default "__VITE_PUBLIC_ASSET__55f4eaf5__"